<template lang="pug">
  .mobile-select(ref="select" :class="{ 'selected': value !== placeholder }" @click="open")
    select(v-model="value" v-if="options.length" @change="selectChange")
      option(:value="placeholder" disabled selected) {{ placeholder }}
      option(v-for="(option, i) in options" :key="i" :value="option") {{ option }}
    span.select.d-flex.align-items-center(v-else)
      span {{ placeholder }}
</template>

<script>
export default {
  name: 'CustomDropdown',
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      value: null,
    };
  },
  watch: {
    placeholder: {
      handler(val) {
        this.value = val;
      },
      immediate: true,
    },
  },
  methods: {
    selectChange(e) {
      this.$emit('select', e.target.value);
    },
    open() {
      if (!this.options.length) {
        this.$emit('open');
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/assets/styles/variables.scss'

.mobile-select
  font-size: 16px
  position: relative
  height: 50px
  display: flex
  border: solid 1px $primary-200 !important
  border-radius: 2px
  overflow: hidden

  select,
  .select
    -webkit-appearance: none
    -moz-appearance: none
    -ms-appearance: none
    appearance: none
    outline: 0
    box-shadow: none
    border: 0
    padding: 10px
    background-color: #fff
    background-image: none

    flex: 1
    cursor: pointer

    &::-ms-expand
      display: none

  &::after
    content: url('~@/assets/images/chevron-down.svg')
    height: 24px
    position: absolute
    top: 50%
    right: 0
    transform: translateY(-50%)
    padding-right: 10px
    cursor: pointer
    pointer-events: none

  &.selected
    // font-size: 12px

    // &::before
    //   content: '排序'
    //   position: absolute
    //   padding: 6px 0 0 10px

    // select
    //   padding: 24px 0 6px 10px
</style>
